module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#group",
      toString: function () {
        return this.url;
      }
    }